<template>
    <div id="topGoodsShare">
        <Header :title="title" />

        <template v-if="app.template.type === '92fanli'">
            <NTfanliTopGoodsShare :style-name="app.template.style" :goods-data="goodsData"
                                  :tpwd="tpwd" :id="id" />
        </template>
        <template v-else-if="app.template.type === 'damai'">
            <DamaiTopGoodsShare :style-name="app.template.style" :goods-data="goodsData"
                                :tpwd="tpwd" :id="id" />
        </template>
        <template v-else>
            <IfanliTopGoodsShare :style-name="app.template.style" :goods-data="goodsData"
                                 :tpwd="tpwd" :id="id" />
        </template>
    </div>
</template>

<script>
    import Header from '../components/Header';
    import {appService} from '../services/app';
    import IfanliTopGoodsShare from './ifanli/TopGoodsShare';
    import NTfanliTopGoodsShare from './92fanli/TopGoodsShare';
    import DamaiTopGoodsShare from './damai/TopGoodsShare';
    import {mapState} from 'vuex';
    import {isEmpty, isMobile} from '../libs/utils';

    export default {
        components: {Header, IfanliTopGoodsShare, NTfanliTopGoodsShare, DamaiTopGoodsShare},
        data() {
            return {
                title: '分享赚钱',
                id: 0,
                goodsData: {
                    num_iid: 0,
                    coupon_after_price: '0.00',
                    reward_amount: 0,
                    zk_final_price: '0.00',
                    user_type: 0,
                    title: '',
                    pict_url: '',
                    coupon_info: '',
                    coupon_discount: 0,
                    coupon_click_url: '',
                    item_url: '',
                },
                tpwd: ''
            }
        },
        computed: {
            ...mapState(['app'])
        },
        watch: {
            id: function (id) {
                if (id > 0) {
                    this.fetchTopGoodsDetail();
                }
            },
            'goodsData.num_iid': function (val) {
                if (val > 0) {
                    this.createTopTpwd();
                }
            }
        },
        created() {
            this.id = Number(this.$route.query.id);

            if (!isMobile()) {
                window.location.href = window.location.origin + '/goods/detail/' + this.id;
            }
        },
        methods: {
            fetchTopGoodsDetail: function () {
                let self = this;
                appService.fetchTopGoodsDetail(self.id).then((res) => {
                    let {code, data} = res;
                    if (code === 200) {
                        self.goodsData = data;
                    }
                });
            },
            createTopTpwd: function () {
                let self = this;

                let url = !isEmpty(this.goodsData.coupon_info) ? this.goodsData.coupon_click_url : this.goodsData.item_url;
                if (!isEmpty(this.$store.getters.userInfo['relation_id'])) {
                    url += '&relationId=' + this.$store.getters.userInfo['relation_id'];
                }

                if (this.goodsData.reward_amount > 0) {
                    appService.createTopTpwd({
                        text: this.goodsData.title,
                        logo: this.goodsData.pict_url,
                        url: url
                    }).then((res) => {
                        let {code, data} = res;
                        if (code === 200) {
                            self.tpwd = data;
                        }
                    });
                } else {
                    self.tpwd = url;
                }
            }
        }
    }
</script>

<style scoped>

</style>
